import type { Brand, CountryName, Region } from '@/types/constants';
import { COOKIES, getCookieValue } from '../cookies';
import { BRAND, BRAND_REGION_MAPPING, COUNTRY_ABBREVIATION, MH_RESERVATION_POSTAL_CODE, REGIONS } from '../constants';

export const getRegion = async () => getCookieValue(COOKIES.REGION) as Promise<Region>;

export const getRegionOrDefault = async (cdnRegion?: string | null, cdnPostalCode?: string | null): Promise<Region> => {
    const country = process.env.COUNTRY as CountryName;
    const brand = process.env.BRAND as Brand;
    const { regions, defaultRegion }: { regions: Region[]; defaultRegion: Region } =
        BRAND_REGION_MAPPING[country][brand];

    const cookieRegion = (await getRegion())?.toUpperCase() as Region | undefined;
    if (cookieRegion && regions.includes(cookieRegion)) {
        return cookieRegion;
    }

    if (brand?.toLowerCase() === BRAND.MOHEGANSUN.toLowerCase()) {
        if (cdnPostalCode === MH_RESERVATION_POSTAL_CODE) {
            return REGIONS.MR;
        }
    }

    const geoRegion = cdnRegion?.toUpperCase() as Region | undefined;
    if (geoRegion && regions.includes(geoRegion)) {
        return geoRegion;
    }

    return defaultRegion;
};

export const getCountryCode = () => {
    const key = (process.env.COUNTRY || '').toUpperCase() as keyof typeof COUNTRY_ABBREVIATION;
    return COUNTRY_ABBREVIATION[key];
};
